module.exports = __webpack_public_path__ + "img/punto_xpress.27cc4e4.png";